import { render } from "./EntityComments.vue?vue&type=template&id=0d0a1905&scoped=true&ts=true"
import script from "./EntityComments.vue?vue&type=script&lang=ts"
export * from "./EntityComments.vue?vue&type=script&lang=ts"

import "./EntityComments.vue?vue&type=style&index=0&id=0d0a1905&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0a1905"]])

export default __exports__